module.exports = __webpack_public_path__ + "static/media/backward_grey.c31e634a.svg";